import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";

const promoDefaultColumns = [
  "TITLE",
  "METHOD",
  "DISCOUNT TYPE",
  "STATUS",
  "START DATE",
  "END DATE",
];

const initialState = {
  promos: {
    results: [],
    count: 0,
  },
  promosParams: {
    offset: 0,
    limit: 10,
  },
  promosSelection: [],
  promoLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: promoDefaultColumns,
      allViews: {
        "Default View": promoDefaultColumns,
      },
      nameOfViews: [],
    },
  },
};

const promoSlice = createSlice({
  name: "promo",
  initialState,
  reducers: {
    setPromos: (state, action) => {
      state.promos = action.payload;
    },
    setPromosSelection: (state, action) => {
      state.promosSelection = action.payload;
    },
    updatePromosParams: (state, action) => {
      state.promosParams = { ...state.promosParams, ...action.payload };
    },
    setPromoLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.promoLayout = {
        ...state.promoLayout,
        listView: {
          ...state.promoLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.promoLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
  },
});

export const { setPromos, setPromosSelection, updatePromosParams, setPromoLayoutAllViews } =
  promoSlice.actions;

export default promoSlice.reducer;
